import { arrayOf, bool, element, expression, listOf, oneOfType, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
const localizedLabelItemShape = shape({
    label: expression,
    value: expression,
});
const localizedLabelShape = shape({
    data: arrayOf(localizedLabelItemShape),
    label: expression,
});
const AboutBoxProperties = {
    cautionIcon: {
        defaultValue: '/static/assets/components/DLS_Brand_Warning.svg',
        type: oneOfType([string, element]),
    },
    companyAddress: {
        defaultValue: 'tws.about-box.company-address',
        type: string,
    },
    companyAddressIcon: {
        defaultValue: '/static/assets/components/DLS_ISO_DateOfManufacture.svg',
        type: oneOfType([string, element]),
    },
    companyAddressOutlineIcon: {
        defaultValue: '/static/assets/components/DLS_ISO_DateOfManufactureOutline.svg',
        type: oneOfType([string, element]),
    },
    companyComplementaryAddress: {
        defaultValue: 'tws.about-box.company-complementary-address',
        type: string,
    },
    companyReference: {
        defaultValue: 'tws.about-box.reference',
        type: string,
    },
    companyReferenceIcon: {
        defaultValue: '/static/assets/components/DLS_ISO_OperatorManual.svg',
        type: oneOfType([string, element]),
    },
    customIcons: {
        defaultValue: [],
        type: listOf(string).notEnumerable(),
    },
    localizedLabel: {
        type: localizedLabelShape,
    },
    logoIcon: {
        defaultValue: '/static/assets/philips-shield.svg',
        type: oneOfType([string, element]),
    },
    lotNumberIcon: {
        defaultValue: '/static/assets/components/DLS_ISO_BatchCode.svg',
        type: oneOfType([string, element]),
    },
    messageExpression: {
        defaultValue: 'tws.about-box.message',
        type: string,
    },
    productExpression: {
        type: string,
    },
    productName: {
        defaultValue: 'tws.about-box.product.name',
        type: string,
    },
    productSubtitle: {
        defaultValue: 'tws.about-box.product.subtitle',
        type: string,
    },
    quantityIcon: {
        defaultValue: '/static/assets/components/DLS_Brand_Quantity.svg',
        type: oneOfType([string, element]),
    },
    referenceIcon: {
        defaultValue: '/static/assets/components/DLS_Brand_REF.svg',
        type: oneOfType([string, element]),
    },
    secondaryMessageExpression: {
        defaultValue: 'tws.about-box.secondary-message',
        type: string,
    },
    showQuantity: {
        defaultValue: true,
        type: bool,
    },
    uniqueDeviceIdentifierIcon: {
        defaultValue: '/static/assets/components/DLS_MDR_UDIMarking.svg',
        type: oneOfType([string, element]),
    },
    versionExpression: {
        defaultValue: 'tws.about-box.version',
        type: string,
    },
};
export { AboutBoxProperties, localizedLabelShape, };
//# sourceMappingURL=about-box-types.js.map